<template>
  <div>
    <!-- <h1>로그인</h1> -->
    <LoginForm></LoginForm>
    <!-- 서비스 이용동의 -->
    <!-- <pop-consent></pop-consent> -->
  </div>
</template>
<script>
import LoginForm from '@/components/auth/LoginForm.vue';
// import PopConsent from '@/components/auth/PopConsent.vue';

export default {
  components: {
    LoginForm,
    // , PopConsent
  },
  created() {
    // console.log('created');
  },
};
</script>
